__turbopack_context__.v({
  "article": "styles-module-scss-module__scg7oq__article",
  "content": "styles-module-scss-module__scg7oq__content",
  "header": "styles-module-scss-module__scg7oq__header",
  "title": "styles-module-scss-module__scg7oq__title",
  "translationPending": "styles-module-scss-module__scg7oq__translationPending",
  "updated": "styles-module-scss-module__scg7oq__updated",
  "wrapper": "styles-module-scss-module__scg7oq__wrapper",
});
